export default __webpack_public_path__ + "static/media/Flip-Card-img-1.a23b9196.jpg";